import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MerchantComponent } from './merchant.component';
import { DialogModule } from 'primeng/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Ng2SearchPipeModule } from 'ng2-search-filter'; // Import Ng2SearchPipeModule
import { DropdownModule } from 'primeng/dropdown';
import { MerchantPaymentComponent } from './merchant-payment/merchant-payment.component';
import { MerchantSubscriptionsComponent } from './merchant-subscriptions/merchant-subscriptions.component';

@NgModule({
  declarations: [
    MerchantComponent,
    MerchantPaymentComponent,
    MerchantSubscriptionsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    NgSelectModule,
    CalendarModule,
    ConfirmDialogModule,
    TranslateModule,
    NgxPaginationModule,
    BreadcrumbModule,
    Ng2SearchPipeModule,
    DropdownModule
  ],
  providers: [ConfirmationService],
  exports: [MerchantComponent, MerchantPaymentComponent, MerchantSubscriptionsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], // Ensure CUSTOM_ELEMENTS_SCHEMA is included
})
export class MerchantModule {}
